import { encaixarPosicaoXZ, encaixarRotacaoGraus } from '../../dominio/tabletop'
import type { TransformacaoTabletop } from '../../dominio/tabletop'

export type PontoChao = readonly [number, number]
export type ModoManipulacaoMesa = 'mover' | 'girar'

export function direcaoGraus(rotacaoY: number): number {
  return ((((rotacaoY * 180) / Math.PI) % 360) + 360) % 360
}

export function moverNoChao(
  original: TransformacaoTabletop,
  inicio: PontoChao,
  atual: PontoChao,
): TransformacaoTabletop {
  return {
    ...original,
    posicao: [
      original.posicao[0] + atual[0] - inicio[0],
      original.posicao[1],
      original.posicao[2] + atual[1] - inicio[1],
    ],
  }
}

export function girarNoChao(
  original: TransformacaoTabletop,
  inicio: PontoChao,
  atual: PontoChao,
): TransformacaoTabletop {
  const [x, , z] = original.posicao
  if (
    Math.hypot(atual[0] - x, atual[1] - z) < 0.1 ||
    Math.hypot(inicio[0] - x, inicio[1] - z) < 0.1
  )
    return original
  const a = Math.atan2(inicio[0] - x, inicio[1] - z)
  const b = Math.atan2(atual[0] - x, atual[1] - z)
  const delta = Math.atan2(Math.sin(b - a), Math.cos(b - a))
  return {
    ...original,
    rotacao: [
      original.rotacao[0],
      original.rotacao[1] + delta,
      original.rotacao[2],
    ],
  }
}

export function encaixarTransformacao(
  t: TransformacaoTabletop,
  passoM?: number | null,
  passoGraus?: number | null,
): TransformacaoTabletop {
  const [x, z] = encaixarPosicaoXZ(t.posicao[0], t.posicao[2], passoM ?? null)
  return {
    ...t,
    posicao: [x, t.posicao[1], z],
    rotacao: [
      t.rotacao[0],
      (encaixarRotacaoGraus(
        (t.rotacao[1] * 180) / Math.PI,
        passoGraus ?? null,
      ) *
        Math.PI) /
        180,
      t.rotacao[2],
    ],
  }
}
